'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildQuickReply;

var _immutable = require('immutable');

var _QuickReply = require('conversations-schema/records/QuickReply');

var _QuickReply2 = _interopRequireDefault(_QuickReply);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildQuickReply(props) {
  if (props) {
    return (0, _QuickReply2.default)({
      quickReplies: (0, _immutable.Set)(props.quickReplies),
      allowMultiSelect: props.allowMultiSelect,
      allowUserInput: props.allowUserInput
    });
  }

  return undefined;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/factories/PubNubMessageFactory/buildQuickReply.js
// module id = 304
// module chunks = 0 1